import { render } from "./CenterSectors.vue?vue&type=template&id=1754821a&scoped=true"
import script from "./CenterSectors.vue?vue&type=script&lang=js"
export * from "./CenterSectors.vue?vue&type=script&lang=js"

import "./CenterSectors.vue?vue&type=style&index=0&id=1754821a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1754821a"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QBtn,QDialog,QCard,QCardSection,QScrollArea,QIcon,QSpinner,QFile,QInput});qInstall(script, 'directives', {ClosePopup});
